/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getUserTyping} from '../api'

 export const useQueryGetUserTyping = createReactQueryHook('getUserTyping', getUserTyping)
